import { ApplicationRef, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { of, startWith, Subject } from 'rxjs';
import { FileUploadDialogData, FileUploadDialogResult } from './file-upload-dialog.model';

@UntilDestroy()
@Component({
  selector: 'y42-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss'],
})
export class FileUploadDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<FileUploadDialogData, FileUploadDialogResult>,
    private readonly applicationRef: ApplicationRef,
    @Inject(MAT_DIALOG_DATA) private readonly data: FileUploadDialogData,
  ) {}

  protected readonly acceptExtensions = this.data.acceptedExtensions;
  protected readonly docsLink = this.data.docsLink;
  protected readonly acceptString = this.acceptExtensions.join(',');

  selectedFile$$ = new Subject<File>();

  protected readonly state = connectState(this, {
    selectedFile: this.selectedFile$$.pipe(startWith(null)),
    sourceHistory: of([]),
  });

  dropped(files: NgxFileDropEntry[]) {
    const fileEntry = files[0]?.fileEntry as FileSystemFileEntry | undefined;

    if (!fileEntry) {
      return;
    }

    fileEntry.file(
      (file: File) => {
        this.selectedFile$$.next(file);
      },
      (err) => {
        console.error(err);
      },
    );
  }

  upload() {
    this.dialogRef.close(this.state.selectedFile);
    // workaround to detect changes when onPush (else popup won't close)
    setTimeout(() => {
      this.applicationRef.tick();
    }, 50);
  }

  cancel() {
    this.dialogRef.close();
  }
}
